<!--隐私协议-->
<template>
    <div class="reload-view">
        <div class="top-back">
<!--            <div class="top-left">-->
<!--                <img class="top-avatar" :src="avatar" alt="爱驿站">-->
<!--            </div>-->
<!--            <div class="top-right">-->
<!--                <div class="code">name</div>-->
<!--                <div class="top-text">123456</div>-->
<!--            </div>-->

        </div>


        <div class="main" style="min-height: 800px">
            <div class="main-option">
                <!-- 情感驿站 -->
            </div>
            <div class="main-list">

                <div class="main-list-info" v-for="item in articleList" :key="item.id">
                    <div class="main-list-info-r" @click="goEssay(item.id)">
                        <div class="main-list-info-name">
                            {{ item.title }}
                        </div>
                        <div class="main-list-info-zz">
                            <div class="main-list-info-text">
                                #{{ item.label }}
                            </div>
                            <div class="main-list-info-time">
                                {{ item.create_time }}
                            </div>
                        </div>
                    </div>

                    <div class="main-list-info-img" @click="goEssay(item.id)">
                        <img :src="item.cover" width="80px" height="80px" alt="爱驿站">
                    </div>
                </div>

            </div>

        </div>
    </div>

</template>

<script setup>
import ayzAjax from "@/plugins/axios";
import {useRouter} from "vue-router";
import { ref } from 'vue'
import { showFailToast } from "vant";
const router = useRouter()


const goEssay = async (id) => {
    return router.push({path: '/essaydetail', query: {id:id}});
}
const articleList = ref([]);

ayzAjax.get('/get_article').then((result)=>{
    if(result.data.code !== 200){
        return showFailToast('网络错误');
    }

    result.data.data.data.forEach((item) => {
        articleList.value.push(item)
    })
})

</script>

<style lang="scss" scoped>

.reload-view{
    background-color: #F6F6F6;
    text-align: left;
    .top-back{
        background-image: url('~@/assets/essay-back.jpg');
        background-size: cover;
        background-repeat: no-repeat;
        width: 100%;
        height: 200px;
        color: #FFFFFF;
        display: flex;
        .top-left{
            overflow: hidden;
            width: 70px;
            height: 70px;
            margin-top: 40px;
            margin-left: 24px;
            border-radius: 50%;
            border: #ffffff 3px solid;
            .top-avatar{
                width: 70px;
                height: 70px;
            }
        }
        .top-right{
            margin-top: 45px;
            .code{
                //padding-top: 30px;
                padding-left: 25px;
                font-weight: 600;
                font-size: 18px;
                color: #FFFFFF;
            }
            .top-text{
                margin-top: 10px;
                margin-left: 25px;
                margin-right: 25px;
                font-weight: 500;
                font-size: 13px;
                color: #FFFFFF;
            }
        }
    }
    .main{
        min-height: 60px;
        // margin: 12px;
        background: #FFFFFF;
        // border-radius: 17px 17px 17px 17px;emotion essay
        .main-cat{
            padding-top: 18px;
            padding-left: 15px;
            padding-right: 25px;
            font-size: 13px;
            color: #161616;
            text-align: left;
            line-height: 25px;
            font-weight: 500;
            .main-num{
                float: right;
                width: 200px;
                height: 25px;
                font-weight: 500;
                font-size: 13px;
                text-align: right;
            }
        }
        .main-option{
            padding-top: 15px;
            margin-left: 15px;
            font-weight: 500;
            font-size: 15px;
            color: #222222;
            // margin-bottom: 25px;
        }
        .main-list-info{

            margin-top: 15px;
            height: 80px;
            //line-height: 50px;
            padding-left: 5px;
            font-size: 12px;
            text-align: center;
            display: flex;
            .main-list-info-img{
                width: 80px;
                height: 80px;
                overflow: hidden;
                border-radius: 5px;
                
            }
            .main-list-info-r{
                width: 75%;
                // padding-left: 10px;
                .main-list-info-name{
                    
                    width: 90%;
                    color: #222222;
                    text-align: left;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    -webkit-line-clamp: 2;
                    overflow: hidden;
                    text-overflow:ellipsis;
                    font-size: 16px;
                    font-weight: 500;
                    height: 50px;
                    margin-left: 10px;
                    line-height: 25px;
                }

                .main-list-info-zz {
                    margin-left: 10px;
                    // width: 100%;
                    height: 20px;
                    margin-top: 10px;
                    .main-list-info-text {
                        width: 100px;
                        float: left;
                        color: #C9C9C9;
                        text-align: left;
                        height: 20px;
                    }
                    .main-list-info-time {
                        float: right;
                        margin-right: 20px;
                        width: 100px;
                        color: #C9C9C9;
                        text-align: right;
                        height: 20px;
                    }
                }
            }

        }
    }
}
.empty{
    margin-top: 100px;
    width: 100%;
    height: 50px;
    color: #555555;
    font-size: 12px;
    text-align: center;
}

</style>
